import { faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import styled from 'styled-components';
import CONSTANTS from '../../constants';
import TimeHelper from '../../helpers/TimeHelper';
import CartService from '../../services/CartService';
import TimePickerModal from './TimePickerModal';

class OrderTime extends Component {
  constructor(props) {
    super(props);
    const current_time = new Date();
    this.state = {
      showTimePickerModal: false,
      current_time,
      order_type_id: this.props.order_type_id,
      order_time: current_time,
      order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
      isPickUpNow: 1,
      loaded: false,
      days: 0,
      isNowEnabled: false
    };
  }

  async componentDidMount() {
    const order_time = this.props.order_time
      ? new Date(this.props.order_time)
      : new Date(this.state.order_time);
    const order_date = this.props.order_date ? this.props.order_date : this.state.order_date;
    const isPickUpNow = this.props.isPickUpNow ? this.props.isPickUpNow : this.state.isPickUpNow;
    this.setState({ order_date, order_time, isPickUpNow, loaded: true });
    if (this.props.location && this.props.order_type_id) {
      const isNowEnabled = await TimeHelper.isNowEnabled(this.props.location, this.props.order_type_id);
      this.setState({ isNowEnabled });
    }
  }

  async toggleTimePickerModal() {
    await this.setState({
      showTimePickerModal: !this.state.showTimePickerModal
    });
  }

  async onChange(event) {
    const target = event.target;
    this.setState({ [target.name]: target.value }, () => {
      this.props.onChange(event);
    });
  }

  async toggleIsPickUpNow() {
    this.setState({ isPickUpNow: 1 }, () => {
      this.onNowSelect(CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.NOW);
    });
  }

  onNowSelect(value) {
    this.changeDate(value, new Date());
  }

  changeDate(orderDate, orderTime, suppressErrors = false) {
    let orderData = CartService.getOrderData(
      this.props.location.orderTypes,
      this.props.location
    );
    orderData.order_time = moment().toDate();
    orderData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
    orderData.isPickUpNow = 1
    CartService.setOrderData(
      orderData,
      this.props.location.orderTypes,
      this.props.location
    );
    this.onChange({ target: { suppressErrors, name: 'order_date', value: orderDate } });
    this.onChange({ target: { suppressErrors, name: 'order_time', value: orderTime } });
    this.onChange({ target: { suppressErrors, name: 'isPickUpNow', value: 1 } });
  }

  timeLabel() {
    let selectedTime = TimeHelper.getDateFromTimeOption(
      this.state.order_date,
      this.state.order_time
    );
    let orderData = CartService.getOrderData(
      this.props.location.orderTypes,
      this.props.location
    );
    orderData.order_time = selectedTime;
    CartService.setOrderData(
      orderData,
      this.props.location.orderTypes,
      this.props.location
    );
    if (TimeHelper.differenceFromNow(selectedTime) < 60) return 'ASAP';
    return moment(selectedTime).format(CONSTANTS.DATE_TIMES.FORMAT.DISPLAY);
  }

  render() {
    const {
      props: { order_type_id, location, workingHours, orderTypes }
    } = this;
    let grid_layout = localStorage.getItem('grid_layout');
    const isNowEnabled = this.state.isNowEnabled;
    if (location.order_lead_time >= 24 && this.state.days === 0) {
      let days = TimeHelper.calDaysDiff(this.state.order_type_id, this.state.order_time, {
        orderTypes: location.orderTypes,
        workingHours: location.workingHours,
        currentTime: moment(this.state.current_time),
        order_lead_time: location.order_lead_time,
        order_max_time: location.order_max_time
      });
      this.setState({ days })
    }
    const isWorkingHours = workingHours.length > 0;
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '';
    let is_custom_time = localStorage.getItem('is_custom_time');


    if (grid_layout === 'old') {
      return (
        <>
          {this.state.loaded && (
            <TimePickerModal
              {...this.state}
              onChange={this.onChange.bind(this)}
              toggleModal={this.toggleTimePickerModal.bind(this)}
              showModal={this.state.showTimePickerModal}
              eventWorkingHours={this.props.eventWorkingHours}
              orderTypes={orderTypes}
              workingHours={workingHours}
              location={location}
              isDelivery={this.props.isDelivery}
              locationSettings={this.props.locationSettings}
              days={this.state.days}
            />
          )}
          <>
            <div className="ps-3 pe-3 order-time-title" id="order_time">
              <div className="time-field mb-3">
                <div className="f3 fw-bold mt-1 ps-2 primary-font-color">{this.props.timeSettings.title}</div>
              </div>
            </div>
            {this.props.timeSettings.isNow && isWorkingHours && this.state.days === 0 && (
              <div
                className={`card flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 no-border card-color cursor ${this.state.isPickUpNow === 2 ? 'bg-transparent' : ''
                  } `}
                onClick={isNowEnabled ? this.toggleIsPickUpNow.bind(this) : console.log}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types " id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 fw-bold">
                          <span
                            class={`fw-semibold cursor type-title ${this.state.isPickUpNow === 2 ? 'primary-font-color' : 'card-font-color'}`}
                          // className='ps-2 cursor type-title'
                          >
                            <FontAwesomeIcon icon={faClock} color={`${this.state.isPickUpNow === 2 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} /> {this.props.timeSettings.label}{' '}
                            Immediately
                          </span>
                          <br></br>
                          <small>
                            <span
                              className={`fw-normal ${!isNowEnabled && 'card-error-color'} working-hour ${this.state.isPickUpNow === 2 ? 'primary-font-color' : 'card-font-color'}`}
                            >
                              {isNowEnabled ? 'Prepare my order ASAP' : 'Out of working hours'}
                            </span>
                          </small>
                        </div>
                        {this.state.isPickUpNow === 1 && (
                          <>
                            <div className="action mt-2">
                              <button className="btn btn-link p-0 highlight-color">
                                {' '}
                                <FontAwesomeIcon icon={faCheckCircle} color={`${this.state.isPickUpNow === 2 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} size={'lg'} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {location.is_adv_ordering === 1 ?

              <div
                className={`card flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 no-border card-color cursor ${this.state.isPickUpNow === 1 ? 'bg-transparent' : ''
                  } `}
                onClick={isWorkingHours ? this.toggleTimePickerModal.bind(this) : console.log}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types" id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 fw-bold">
                          <span class={`fw-semibold type-title cursor ${this.state.isPickUpNow === 1 ? 'primary-font-color' : 'card-font-color'}`}>
                            <FontAwesomeIcon icon={faClock} color={`${this.state.isPickUpNow === 1 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} /> {this.props.timeSettings.label} Later
                          </span>
                          <br></br>
                          <small>
                            <span
                              className={`fw-normal ${!isWorkingHours && 'card-error-color'} ${this.state.isPickUpNow === 1 ? 'primary-font-color' : 'card-font-color'} working-hour`}
                            >
                              {!isWorkingHours
                                ? 'This restaurant has no working hours'
                                : this.state.isPickUpNow === 2
                                  ? this.timeLabel()
                                  : 'Prepare my order for a later time'}
                            </span>
                          </small>
                        </div>
                        {this.state.isPickUpNow === 2 && isWorkingHours && (
                          <>
                            <div className="action mt-2">
                              <button className="btn btn-link p-0 highlight-color">
                                {' '}
                                <FontAwesomeIcon icon={faCheckCircle} size={'lg'} color={`${this.state.isPickUpNow === 1 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : ''
            }
          </>
        </>
      );
    } else if (grid_layout !== 'old') {
      return (
        <StyledDeliveryLater>
          {this.state.loaded && (
            <TimePickerModal
              {...this.state}
              onChange={this.onChange.bind(this)}
              toggleModal={this.toggleTimePickerModal.bind(this)}
              showModal={this.state.showTimePickerModal}
              eventWorkingHours={this.props.eventWorkingHours}
              orderTypes={orderTypes}
              workingHours={workingHours}
              location={location}
              isDelivery={this.props.isDelivery}
              locationSettings={this.props.locationSettings}
            />
          )}
          <>
            <div className="ps-3 pe-3 order-time-title" id="order_time">
              <div className="time-field mb-3">
                <div className="f3 fw-bold mt-1 primary-font-color">
                  <span className="ps-2">{this.props.timeSettings.title}</span>
                </div>
              </div>
            </div>
            {this.props.timeSettings.isNow && isWorkingHours && this.state.days === 0 && (
              <div
                className={`card card-custom flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pb-3 pt-3 ${this.state.isPickUpNow === 1 ? '' : 'no-border'} card-color ${card_outline} cursor ${this.state.isPickUpNow === 2 ? 'bg-transparent' : 'active-card'
                  } `}
                onClick={isNowEnabled ? this.toggleIsPickUpNow.bind(this) : console.log}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types " id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 text-bold">
                          <span className={`ps-2 cursor type-title ${this.state.isPickUpNow === 2 ? 'primary-font-color' : 'card-font-color'} `}>
                            <FontAwesomeIcon icon={faClock} color={`${this.state.isPickUpNow === 2 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} /> {this.props.timeSettings.label}{' '}
                            Immediatly
                          </span>
                          <br></br>
                          <small>
                            <span className={`ps-2 ${!isNowEnabled && 'card-error-color'} working-hour ${this.state.isPickUpNow === 2 ? 'primary-font-color' : 'card-font-color'}`}>
                              {isNowEnabled ? 'Prepare my order ASAP' : 'Out of working hours'}
                            </span>
                          </small>
                        </div>
                        {this.state.isPickUpNow === 1 && (
                          <>
                            <div className="action mt-2 pe-2">
                              <button className="btn btn-link p-0 highlight-color">
                                {' '}
                                <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {location.is_adv_ordering === 1 ?
              < div
                className={`card card-custom-later flex-md-row mb-2 box-shadow h-md-250 p-1 m-3 pt-3 ${this.state.isPickUpNow === 2 ? '' : 'no-border'} card-color cursor ${this.state.isPickUpNow === 1 ? 'bg-transparent' : 'active-card'
                  } `}
                onClick={isWorkingHours ? this.toggleTimePickerModal.bind(this) : console.log}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types" id="order_type_id">
                    <div className="ps-3 pe-3" id="order_time">
                      <div className="time-field mb-3">
                        <div className="f3 text-bold">
                          <span className={`ps-2 type-title cursor ${this.state.isPickUpNow === 1 ? 'primary-font-color' : 'card-font-color'} `}>
                            <FontAwesomeIcon icon={faClock} color={`${this.state.isPickUpNow === 1 ? 'var(--primary-font-color)' : 'var(--card-font-color)'}`} /> {this.props.timeSettings.label} Later
                          </span>
                          <br></br>
                          <small>
                            <span className={`ps-2 ${!isWorkingHours && 'primary-error-font-color '} working-hour ${this.state.isPickUpNow === 1 ? 'primary-font-color' : 'card-font-color'}`}>
                              {!isWorkingHours
                                ? 'This restaurant has no working hours'
                                : this.state.isPickUpNow === 2
                                  ? this.timeLabel()
                                  : 'Prepare my order for a later time'}
                            </span>
                          </small>
                        </div>
                        {this.state.isPickUpNow === 2 && isWorkingHours && (
                          <>
                            <div className="action mt-2">
                              <button className="btn btn-link p-0 highlight-color">
                                {' '}
                                <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div> : ''
            }
          </>
        </StyledDeliveryLater >
      );
    }
  }
}
const StyledDeliveryLater = styled.div`
  .bg-transparent {
    background: transparent !important;
    box-shadow: unset !important;
  }
`;
export default OrderTime;
